import { Check, Clock, Archive, CheckSquare, X } from 'lucide-react';

/**
 * Inline bulk-action bar for the Today DecisionQueue.
 *
 * Renders at the bottom of the queue (NOT floating) when selectMode is on
 * and at least one decision is checked. Distinct from the shared
 * `components/common/BulkActionBar.js`, which is a generic, floating
 * Tier-3 pill for views like Inbox / Calls / Reading / Payments.
 */
export default function BulkActionBar({ selected, onBulkComplete, onBulkDefer, onBulkArchive, onClearSelection }) {
  const count = selected.length;
  if (count === 0) return null;

  return (
    <div
      data-testid="bulk-action-bar"
      className="flex items-center gap-2 px-4 py-2.5"
      style={{ background: 'var(--pd-text)', borderTop: '1px solid var(--pd-border)' }}
    >
      <div className="flex items-center gap-1.5 mr-auto">
        <CheckSquare className="w-3.5 h-3.5 text-white" />
        <span className="text-[11px] font-bold text-white tabular-nums">{count} selected</span>
      </div>
      <button
        data-testid="bulk-complete-btn"
        onClick={onBulkComplete}
        className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[10px] font-semibold transition-all hover:scale-105 active:scale-95"
        style={{ background: 'var(--pd-success)', color: 'white' }}
      >
        <Check className="w-3 h-3" />Complete
      </button>
      <button
        data-testid="bulk-defer-btn"
        onClick={onBulkDefer}
        className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[10px] font-semibold transition-all hover:scale-105 active:scale-95"
        style={{ background: 'var(--pd-warning)', color: 'white' }}
      >
        <Clock className="w-3 h-3" />Defer
      </button>
      <button
        data-testid="bulk-archive-btn"
        onClick={onBulkArchive}
        className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-[10px] font-semibold transition-all hover:scale-105 active:scale-95"
        style={{ background: 'var(--pd-crimson)', color: 'white' }}
      >
        <Archive className="w-3 h-3" />Archive
      </button>
      <button
        data-testid="bulk-clear-btn"
        onClick={onClearSelection}
        className="flex items-center gap-1 px-2 py-1.5 rounded-lg text-[10px] font-medium transition-all hover:scale-105"
        style={{ color: 'rgba(255,255,255,0.7)' }}
      >
        <X className="w-3 h-3" />Clear
      </button>
    </div>
  );
}
